import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setupStore } from './store'
import "ant-design-vue/dist/antd.css";
createApp(App).use(setupStore).use(router).mount('#app')
